import { Link } from 'react-router-dom'
import { ReactComponent as PlayIcon } from '../../assets/images/illustrations/il-play-button.svg'
import styles from './VideoCard.module.css'

export default function VideoCard({ video, style }) {
  return <Link to={`/videos/${video.id}`} className={styles.container} style={style}>
    <div className={styles.playerWrapper}>
      {video.thumbnail && <img src={video.thumbnail} alt="" loading="lazy" />}
      <span className={styles.play}><PlayIcon /></span>
    </div>
    <div className={styles.info}><h3 className={styles.title}>{video.title}</h3>
      <div className={styles.tags}>{(video.tags || []).map(tag => <span key={tag.id} className={styles.tag}>{tag.name}</span>)}</div>
    </div>
  </Link>
}
